import "core-js/modules/es.array.concat";
export default (function (_ref) {
  var service = _ref.service,
      request = _ref.request,
      tools = _ref.tools;
  return {
    /**
     * 题目列表（分页/筛选/搜索）
     */
    loadQuestionList: function loadQuestionList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/api/questions',
        method: 'get',
        params: data
      });
    },

    /**
     * 题目详情
     */
    getQuestion: function getQuestion(id) {
      return request({
        url: "/api/questions/".concat(id),
        method: 'get'
      });
    },

    /**
     * 创建题目
     */
    createQuestion: function createQuestion(data) {
      return request({
        url: '/api/questions',
        method: 'post',
        data: data
      });
    },

    /**
     * 更新题目
     */
    updateQuestion: function updateQuestion(id, data) {
      return request({
        url: "/api/questions/".concat(id),
        method: 'put',
        data: data
      });
    },

    /**
     * 删除题目
     */
    deleteQuestion: function deleteQuestion(id) {
      return request({
        url: "/api/questions/".concat(id),
        method: 'delete'
      });
    },

    /**
     * 按知识点查询题目
     */
    getQuestionsByNode: function getQuestionsByNode(nodeId) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return request({
        url: "/api/questions/by-node/".concat(nodeId),
        method: 'get',
        params: data
      });
    },

    /**
     * 获取题目已绑定知识点的完整知识图谱路径详情
     */
    getQuestionNodeDetail: function getQuestionNodeDetail(questionId) {
      return request({
        url: "/api/questions/".concat(questionId, "/nodes/detail"),
        method: 'get'
      });
    },

    /**
     * 获取题目关联知识点
     */
    getQuestionNodes: function getQuestionNodes(questionId) {
      return request({
        url: "/api/questions/".concat(questionId, "/nodes"),
        method: 'get'
      });
    },

    /**
     * 绑定知识点
     */
    bindQuestionNode: function bindQuestionNode(questionId, data) {
      return request({
        url: "/api/questions/".concat(questionId, "/nodes"),
        method: 'post',
        data: data
      });
    },

    /**
     * 解绑知识点
     */
    unbindQuestionNode: function unbindQuestionNode(questionId, nodeId) {
      return request({
        url: "/api/questions/".concat(questionId, "/nodes/").concat(nodeId),
        method: 'delete'
      });
    },

    /**
     * 自动绑定知识点
     */
    autoBindNodes: function autoBindNodes(questionId) {
      return request({
        url: "/api/questions/".concat(questionId, "/nodes/auto-bind"),
        method: 'post'
      });
    },

    /**
     * 批量自动绑定知识点（词汇层 + 句法层），返回实际产生绑定的题目ID列表
     */
    autoBindNodesBatch: function autoBindNodesBatch(questionIds) {
      return request({
        url: '/api/questions/batch/auto-bind',
        method: 'post',
        data: {
          questionIds: questionIds
        }
      });
    },

    /**
     * 一键全量自动绑定：为所有未绑定知识点的题目自动匹配绑定（已绑定跳过）
     * 返回统计：{processed, bound, skipped}
     */
    autoBindAllNodes: function autoBindAllNodes() {
      return request({
        url: '/api/questions/batch/auto-bind-all',
        method: 'post'
      });
    },

    /**
     * 清空重绑：删除全部存量绑定后按当前规则对所有题目统一重绑（纠偏历史错绑）
     * 返回统计：{processed, bound, noMatch}
     */
    autoBindRebuild: function autoBindRebuild() {
      return request({
        url: '/api/questions/batch/auto-bind-rebuild',
        method: 'post'
      });
    },

    /**
     * 获取评测报告列表
     */
    getReportList: function getReportList(userId) {
      return request({
        url: "/api/report/list/".concat(userId),
        method: 'get'
      });
    },

    /**
     * 获取评测报告详情
     */
    getReport: function getReport(id) {
      return request({
        url: "/api/report/".concat(id),
        method: 'get'
      });
    },

    /**
     * 题目媒体上传（图片/音频），复用后端既有通用上传接口 /api/audio/upload（AudioUploadController）
     * cosKey 约定：图片 images/question/q_xxx.png，音频 audio/question/q_xxx.mp3
     * 返回 { url, cosKey, success }
     */
    uploadQuestionMedia: function uploadQuestionMedia(file, cosKey) {
      var formData = new FormData();
      formData.append('file', file);
      formData.append('cosKey', cosKey);
      return request({
        url: '/api/audio/upload',
        method: 'post',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    },

    /**
     * 知识图谱概览（年级code + 册别book -> 单元列表）
     * 单元项含 code/name_en/theme_cn
     */
    getKgOverview: function getKgOverview(grade, book) {
      return request({
        url: '/kg/overview',
        method: 'get',
        params: {
          grade: grade,
          book: book
        }
      });
    },

    /**
     * 知识图谱单元节点（年级code + 册别book + 单元unit -> 知识点列表）
     * 节点项含 id(nodeId)/name/type
     */
    getKgUnit: function getKgUnit(grade, book, unit) {
      return request({
        url: '/kg/unit',
        method: 'get',
        params: {
          grade: grade,
          book: book,
          unit: unit
        }
      });
    }
  };
});